import { useEffect, useState } from "react";
import { getCampaignForTransaction } from "Utils/CampaignStorage";

/**
 * Hook to check if a transaction has an associated campaign stored in localStorage
 */
export const useCampaignData = (transactionId: string) => {
  const [campaignCode, setCampaignCode] = useState<string | null>(null);

  useEffect(() => {
    if (transactionId) {
      const campaignCode = getCampaignForTransaction(transactionId);
      setCampaignCode(campaignCode);
    }
  }, [transactionId]);

  return campaignCode;
};
